/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetOccasionScheduledMessageByIdDto } from '../models/custom-result-of-get-occasion-scheduled-message-by-id-dto';
import { CustomResultOfPaginatedListOfGetOccasionScheduledMessagesWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-occasion-scheduled-messages-with-pagination-dto';
import { occasionScheduledMessagesCreateGet } from '../fn/occasion-scheduled-messages/occasion-scheduled-messages-create-get';
import { OccasionScheduledMessagesCreateGet$Params } from '../fn/occasion-scheduled-messages/occasion-scheduled-messages-create-get';
import { occasionScheduledMessagesCreatePost } from '../fn/occasion-scheduled-messages/occasion-scheduled-messages-create-post';
import { OccasionScheduledMessagesCreatePost$Params } from '../fn/occasion-scheduled-messages/occasion-scheduled-messages-create-post';
import { occasionScheduledMessagesDelete } from '../fn/occasion-scheduled-messages/occasion-scheduled-messages-delete';
import { OccasionScheduledMessagesDelete$Params } from '../fn/occasion-scheduled-messages/occasion-scheduled-messages-delete';
import { occasionScheduledMessagesGetOccasionScheduledMessageAuditWithPagination } from '../fn/occasion-scheduled-messages/occasion-scheduled-messages-get-occasion-scheduled-message-audit-with-pagination';
import { OccasionScheduledMessagesGetOccasionScheduledMessageAuditWithPagination$Params } from '../fn/occasion-scheduled-messages/occasion-scheduled-messages-get-occasion-scheduled-message-audit-with-pagination';
import { occasionScheduledMessagesGetOccasionScheduledMessagesWithPagination } from '../fn/occasion-scheduled-messages/occasion-scheduled-messages-get-occasion-scheduled-messages-with-pagination';
import { OccasionScheduledMessagesGetOccasionScheduledMessagesWithPagination$Params } from '../fn/occasion-scheduled-messages/occasion-scheduled-messages-get-occasion-scheduled-messages-with-pagination';
import { occasionScheduledMessagesUpdateGet } from '../fn/occasion-scheduled-messages/occasion-scheduled-messages-update-get';
import { OccasionScheduledMessagesUpdateGet$Params } from '../fn/occasion-scheduled-messages/occasion-scheduled-messages-update-get';
import { occasionScheduledMessagesUpdatePut } from '../fn/occasion-scheduled-messages/occasion-scheduled-messages-update-put';
import { OccasionScheduledMessagesUpdatePut$Params } from '../fn/occasion-scheduled-messages/occasion-scheduled-messages-update-put';

@Injectable({ providedIn: 'root' })
export class OccasionScheduledMessagesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `occasionScheduledMessagesCreateGet()` */
  static readonly OccasionScheduledMessagesCreateGetPath = '/OccasionScheduledMessages/Create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `occasionScheduledMessagesCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  occasionScheduledMessagesCreateGet$Response(params?: OccasionScheduledMessagesCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return occasionScheduledMessagesCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `occasionScheduledMessagesCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  occasionScheduledMessagesCreateGet(params?: OccasionScheduledMessagesCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.occasionScheduledMessagesCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `occasionScheduledMessagesCreatePost()` */
  static readonly OccasionScheduledMessagesCreatePostPath = '/OccasionScheduledMessages/Create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `occasionScheduledMessagesCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  occasionScheduledMessagesCreatePost$Response(params: OccasionScheduledMessagesCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return occasionScheduledMessagesCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `occasionScheduledMessagesCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  occasionScheduledMessagesCreatePost(params: OccasionScheduledMessagesCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.occasionScheduledMessagesCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `occasionScheduledMessagesUpdateGet()` */
  static readonly OccasionScheduledMessagesUpdateGetPath = '/OccasionScheduledMessages/Update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `occasionScheduledMessagesUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  occasionScheduledMessagesUpdateGet$Response(params?: OccasionScheduledMessagesUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetOccasionScheduledMessageByIdDto>> {
    return occasionScheduledMessagesUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `occasionScheduledMessagesUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  occasionScheduledMessagesUpdateGet(params?: OccasionScheduledMessagesUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetOccasionScheduledMessageByIdDto> {
    return this.occasionScheduledMessagesUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetOccasionScheduledMessageByIdDto>): CustomResultOfGetOccasionScheduledMessageByIdDto => r.body)
    );
  }

  /** Path part for operation `occasionScheduledMessagesUpdatePut()` */
  static readonly OccasionScheduledMessagesUpdatePutPath = '/OccasionScheduledMessages/Update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `occasionScheduledMessagesUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  occasionScheduledMessagesUpdatePut$Response(params: OccasionScheduledMessagesUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return occasionScheduledMessagesUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `occasionScheduledMessagesUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  occasionScheduledMessagesUpdatePut(params: OccasionScheduledMessagesUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.occasionScheduledMessagesUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `occasionScheduledMessagesDelete()` */
  static readonly OccasionScheduledMessagesDeletePath = '/OccasionScheduledMessages/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `occasionScheduledMessagesDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  occasionScheduledMessagesDelete$Response(params: OccasionScheduledMessagesDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return occasionScheduledMessagesDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `occasionScheduledMessagesDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  occasionScheduledMessagesDelete(params: OccasionScheduledMessagesDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.occasionScheduledMessagesDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `occasionScheduledMessagesGetOccasionScheduledMessagesWithPagination()` */
  static readonly OccasionScheduledMessagesGetOccasionScheduledMessagesWithPaginationPath = '/OccasionScheduledMessages/GetOccasionScheduledMessagesWithPagination';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `occasionScheduledMessagesGetOccasionScheduledMessagesWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  occasionScheduledMessagesGetOccasionScheduledMessagesWithPagination$Response(params: OccasionScheduledMessagesGetOccasionScheduledMessagesWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetOccasionScheduledMessagesWithPaginationDto>> {
    return occasionScheduledMessagesGetOccasionScheduledMessagesWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `occasionScheduledMessagesGetOccasionScheduledMessagesWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  occasionScheduledMessagesGetOccasionScheduledMessagesWithPagination(params: OccasionScheduledMessagesGetOccasionScheduledMessagesWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetOccasionScheduledMessagesWithPaginationDto> {
    return this.occasionScheduledMessagesGetOccasionScheduledMessagesWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetOccasionScheduledMessagesWithPaginationDto>): CustomResultOfPaginatedListOfGetOccasionScheduledMessagesWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `occasionScheduledMessagesGetOccasionScheduledMessageAuditWithPagination()` */
  static readonly OccasionScheduledMessagesGetOccasionScheduledMessageAuditWithPaginationPath = '/OccasionScheduledMessages/GetOccasionScheduledMessageAuditWithPagination';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `occasionScheduledMessagesGetOccasionScheduledMessageAuditWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  occasionScheduledMessagesGetOccasionScheduledMessageAuditWithPagination$Response(params: OccasionScheduledMessagesGetOccasionScheduledMessageAuditWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return occasionScheduledMessagesGetOccasionScheduledMessageAuditWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `occasionScheduledMessagesGetOccasionScheduledMessageAuditWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  occasionScheduledMessagesGetOccasionScheduledMessageAuditWithPagination(params: OccasionScheduledMessagesGetOccasionScheduledMessageAuditWithPagination$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.occasionScheduledMessagesGetOccasionScheduledMessageAuditWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

}
